import { Module } from 'vuex'
import { actConf, ruleCheck } from '$services/index'

interface ActState {
  actConfig: any
  ruleGroupList: any[]
  ruleGroupCheckList: any[]
}

const act: Module<ActState, any> = {
  namespaced: true,
  state: {
    actConfig: '', // 活动配置信息
    ruleGroupList: [], // 活动规则组
    ruleGroupCheckList: [], // 活动规则组装状态
  },
  getters: {
    // 活动配置
    actConfig(state) {
      let config = {
        actStatus: 2,
        actStartTime: '',
        actEndTime: '',
        currentTime: +new Date(),
        ext: {}
      }
      if (typeof state.actConfig === 'object') {
        config = state.actConfig
      }
      return {
        ...config,
      }
    },
    // 活动是否进行中
    actRunning(state, getters) {
      return getters.actConfig.actStatus === 2
    },
  },
  mutations: {
    updateActConfig(state, config) {
      state.actConfig = config
    },
    updateRuleGroupList(state, data) {
      state.ruleGroupList = data
    },
    updateRuleGroupCheckList(state, data) {
      state.ruleGroupCheckList = data
    },
  },
  actions: {
    // 初始化信息
    async bootstrap({ dispatch, rootState } :any, { force = false } = {}) {
      force && console.log('强制刷新 bootstrap')
      await dispatch('slientLogin', null, { root: true })
      await dispatch('initActConfig', { force })
      // 已登录
      if (rootState.common.loginState) {
        await dispatch('initRuleGroupCheckList', { force })
      }
    },
    // 初始化活动信息
    initActConfig({ commit, state, getters }, { force = false } = {}) {
      force && console.log('强制刷新 initActConfig')
      if (typeof state.actConfig === 'object' && !force) {
        return Promise.resolve(getters.actConfig)
      }
      return actConf().then((data: any) => {
        // 修改系统当前时间
        data.actInfoResp.currentTime = data.systemTime
        commit('updateActConfig', data.actInfoResp)
        commit('updateRuleGroupList', data.ruleGroupList)
        return getters.actConfig
      }).catch((e: any) => {
        console.log('[initActConfig]获取活动信息失败', e)
      })
    },
    // 初始化 规则组信息
    initRuleGroupCheckList({ commit, state }, { force = false } = {}) {
      force && console.log('强制刷新 initRuleGroupCheckList')
      if (state.ruleGroupCheckList && state.ruleGroupCheckList.length > 0 && !force) {
        return Promise.resolve(state.ruleGroupCheckList)
      }
      return ruleCheck().then((data: any) => {
        const { ruleGroupCheckList } = data
        commit('updateRuleGroupCheckList', ruleGroupCheckList)
        return state.ruleGroupCheckList
      }).catch((e: any) => {
        console.log('[initRuleGroupCheckList] 失败', e)
      })
    },
  }
}

export default act
